//引入外部模組
import 'jquery-lazy/jquery.lazy.min';
import 'jquery-lazy/jquery.lazy.plugins.min';




//圖片延遲載入
class LazyLoad {
  constructor() {
    this.img        = $('img.lazy');
    this.imgNoCrop  = $('img.noCropLazy');
    this.imgScroll  = $('img.lazyS');
    this.scrollLazy = $('.scrollLazy');
  }
  imgLoad() {
    this.img.lazy({
      delay: 1000,
      afterLoad: (e) => {
        //物件列表圖片裁切
        e.parent().css('background-image', 'url(' + e.attr('src') + ')');
        e.parent().empty();
      }
    });
  }
  scrollImgLoad() {
    this.imgScroll.lazy({
      appendScroll: this.scrollLazy,
      afterLoad: (e) => {
        //物件列表圖片裁切
        e.parent().css('background-image', 'url(' + e.attr('src') + ')');
        e.parent().empty();
      }
    });
  }
  noImgCropLoad() {
    this.imgNoCrop.lazy({
      afterLoad: (e) => {
        // e.parent().css('background-image', 'none'); //原設定
        e.parent().css('background-image', 'url("images/recruitment/logo1.png")'); //20230210 kai write
      }
    });
  }
}




//輸出
export {LazyLoad};


// WEBPACK FOOTER //
// ./js_new/lazyload.js